import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaDeIdsDeOcorrencias = () => {
    const [listaIdsDeOcorrencia, setListaIdsDeOcorrencias] = useState([])

    const buscaListaDeIdsDeOcorrencias = useCallback(() => {
        http.get('/ocorrencias-id')
            .then(res => {
                const listaOcorrencias = res.data
                setListaIdsDeOcorrencias(listaOcorrencias)
            })
            .catch(() => {
                setListaIdsDeOcorrencias([])
            })
    }, [])

    useEffect(() => {
        buscaListaDeIdsDeOcorrencias()
    }, [buscaListaDeIdsDeOcorrencias])

    useRecarregaAoRenovarToken(buscaListaDeIdsDeOcorrencias)

    return {
        listaIdsDeOcorrencia
    }
}
